import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import PropTypes from "prop-types";
import L from "leaflet"; // Ensure L is imported
import { getBranchPerformance } from "services/api";

// Fix for missing marker icon
const customIcon = new L.Icon({
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
  shadowSize: [41, 41],
});

const EgyptMap = ({ branches, center }) => {
  return (
    <MapContainer
      center={center} // Egypt's latitude and longitude
      zoom={6}
      style={{ height: "500px", width: "100%" }}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      {branches?.map((branch, index) => (
        <Marker
          key={index}
          position={[branch.latitude, branch.longitude]}
          // icon={customIcon} eventHandlers={{ click: () => handleMarkerClick(branch.branchId) }}
          icon={customIcon}
        >
          <Popup>
            <strong>{branch.branchName}</strong> <br />
            📍 {branch.address}
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

EgyptMap.propTypes = {
  branches: PropTypes.arrayOf(
    PropTypes.shape({
      latitude: PropTypes.number.isRequired,
      longitude: PropTypes.number.isRequired,
      branchId: PropTypes.number.isRequired,
      branchName: PropTypes.string.isRequired,
      address: PropTypes.string.isRequired,
    })
  ).isRequired,
  center: PropTypes.array.isRequired,
};

export default EgyptMap;
